import Model from './voucher_card.model'

let storeContent = utils.generateStore({
   Model,
   voucher_cards: [],
   selected_voucher_cards: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async filterVouchersCards(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpointSecure({
                  resource: 'commons',
                  action: 'list',
                  data: {
                     rules: {
                        match: {
                           created_at: {
                              $gte: dayjs(`${data.date[0]} 00:00:00`,'DD-MM-YYYY HH:mm:SS').toISOString(),
                              $lte: dayjs(`${data.date[1]} 23:59:59`,'DD-MM-YYYY HH:mm:SS').toISOString(),
                           }
                        }
                     }
                  },
                  meta_data: {
                     service: "rewards",
                     collection: "voucher_card",
                  }
               })
               ctx.commit('voucher_cards', res.result.records);
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx, payload) {

      },
      async fetchVoucherCardsForVoucher(ctx, payload) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {
                        voucher_id: payload.voucher_id
                     }
                  }
               },
               meta_data: {
                  service: "rewards",
                  collection: "voucher_card",
               }
            })
            ctx.commit('voucher_cards', res.result.records);

            Event.$emit('loader:show', false)
         } catch (err) {
            Event.$emit('loader:show', false)
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};